var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1F9Ec(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#77B255",
    d: "M3.019 26.246l3.432 3.432-.923.922-3.432-3.431z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD983",
    d: "M6.362 29.587l3.431 3.432-.923.923-3.43-3.432z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M6.273 24.237l3.432 3.432-.923.923L5.35 25.16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M8.998 26.962l3.432 3.432-.923.923-3.431-3.432zm3.909-9.359l3.431 3.432-.923.923-3.431-3.432z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M15.631 20.329l3.432 3.431-.923.923-3.432-3.431z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#77B255",
    d: "M14.97 14.377l3.432 3.432-.922.923-3.432-3.432z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD983",
    d: "M18.277 17.683l3.432 3.432-.923.923-3.432-3.432z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M17.616 11.731l3.432 3.432-.923.922-3.432-3.431z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M20.923 15.038l3.432 3.431-.923.923-3.431-3.432zM24.387 4.96l3.432 3.432-.923.922-3.432-3.431z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M27.694 8.267l3.432 3.431-.923.923-3.432-3.432z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#77B255",
    d: "M27.013 2.252l3.432 3.432-.923.923-3.432-3.432z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD983",
    d: "M30.36 5.6l3.432 3.431-.923.923-3.432-3.431z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9266CC",
    d: "M24.922.812c-2.52 2.52-2.601 6.145-2.396 9.806.501.028 1.002.061 1.502.094.39.026.775.051 1.159.074-.198-3.286-.199-6.299 1.606-8.104.727-.703.955-1.653.447-2.166-.535-.54-1.542-.497-2.318.296z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B88C3",
    d: "M13.146 25.65l-.153-2.66c-.026-.445-.058-.899-.074-1.332-.296-.296-2.466-.349-2.653-.162.013.44.047.884.071 1.327.028.502.126 2.275.149 2.66.054.91.096 1.806.086 2.656.259.259 2.371.437 2.645.162.015-.872-.022-1.761-.071-2.651z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M13.22 28.3l-2.649-.162c-.026 2.209-.384 4.145-1.687 5.448-.517.517-.517 1.354 0 1.871.258.258.597.388.935.388.338 0 .677-.129.935-.388 2.423-2.422 2.467-7.174 2.466-7.157z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#9266CC",
    d: "M25.354 13.447c-.501-.028-1.003-.061-1.503-.094-.389-.026-.775-.051-1.158-.074.198 3.285.199 6.299-1.607 8.104-1.804 1.804-4.813 1.805-8.094 1.607-.386-.023-2.159-.14-2.656-.168-3.667-.206-7.297-.126-9.82 2.397-.516.516-.516 1.353.001 1.87.258.258.597.388.935.388.338 0 .677-.129.935-.388 1.805-1.804 4.815-1.806 8.098-1.608.385.023 2.161.14 2.66.168 3.662.205 7.289.125 9.811-2.396 2.521-2.52 2.603-6.145 2.398-9.806z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#744EAA",
    d: "M25.354 13.447c-.028-.501-.145-2.277-.168-2.66-.027-.45-.049-.894-.064-1.332-.336-.021-2.1-.133-2.653-.163.013.44.032.883.056 1.326.028.501.145 2.277.168 2.661.055.914.091 1.804.081 2.656.333.021 2.094.132 2.645.162.015-.872-.015-1.759-.065-2.65z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M35.581 8.827c-.42-.436-1.385-.601-2.291.353-1.805 1.805-4.817 1.806-8.104 1.607-.384-.023-2.16-.141-2.661-.169-3.66-.205-7.286-.123-9.806 2.397-2.215 2.215-2.545 5.284-2.453 8.48.553.03 2.319.142 2.653.162-.098-2.755.113-5.214 1.671-6.772 1.805-1.805 4.818-1.805 8.104-1.607.383.023 2.16.14 2.661.168 3.661.205 7.286.124 9.806-2.396.886-.869.84-1.787.42-2.223z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F9Ec);
export default __webpack_public_path__ + "static/media/1f9ec.33b6a783f21242a7bc8e027da47c8d6a.svg";
export { ForwardRef as ReactComponent };